import { useState } from "react";
import TarotCardFlip, { cardOfTheDay } from "@/components/TarotCardFlip";

export default function Tarot() {
  const [revealed, setRevealed] = useState(false);
  const [card] = useState(cardOfTheDay);

  return (
    <section id="tarot" className="relative py-24 lg:py-36 bg-[#1A0F0B] border-y border-[#C9A24B]/12 overflow-hidden" data-testid="tarot-section">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-[#9C2A52]/10 blur-[130px] -z-0" />

      <div className="relative z-10 mx-auto max-w-[900px] px-6 lg:px-10 flex flex-col items-center text-center">
        <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A24B] mb-4">✦ Daily Tarot ✦</span>
        <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[#EFE3CC]">
          Your card for <span className="italic text-gold-gradient">today</span>
        </h2>
        <p className="mt-4 mb-12 text-sm text-[#B7A488] font-light max-w-md">
          {revealed ? "The cards have spoken. Sit with the message a moment." : "Quiet your mind, breathe, and tap the card when you're ready."}
        </p>

        <TarotCardFlip card={card} revealed={revealed} onReveal={() => setRevealed(true)} testidPrefix="tarot" />
      </div>
    </section>
  );
}
